import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { useSheetFullScreen } from './ResponsiveSheet';
import { TOKENS } from '../theme';

// Header for the manager-edit sheets (transaction / bonus / raffle).
//
// Desktop shows a modal, so the dismiss affordance is a trailing X. Mobile
// shows the sheet as a full-screen page, so it gets a leading back arrow
// instead — the standard "this is a page you can return from" affordance.
// Sticky either way so the title stays put while the form scrolls.
export default function SheetHeader({ eyebrow, eyebrowColor, title, onClose }) {
  const isPage = useSheetFullScreen();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1,
        px: isPage ? 1 : 2,
        py: 1.5,
        borderBottom: `1px solid ${TOKENS.slate200}`,
        position: 'sticky',
        top: 0,
        zIndex: 2,
        background: '#fff',
      }}
    >
      {isPage && (
        <IconButton onClick={onClose} aria-label="Back" edge="start">
          <ArrowBackIcon />
        </IconButton>
      )}
      <Box sx={{ flex: 1, minWidth: 0 }}>
        {eyebrow && (
          <Typography
            sx={{
              fontSize: 10,
              fontWeight: 700,
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              color: eyebrowColor || TOKENS.slate500,
            }}
          >
            {eyebrow}
          </Typography>
        )}
        <Typography
          noWrap
          sx={{ fontSize: 18, fontWeight: 700, color: TOKENS.slate900 }}
        >
          {title}
        </Typography>
      </Box>
      {!isPage && (
        <IconButton onClick={onClose} aria-label="Close">
          <CloseIcon />
        </IconButton>
      )}
    </Box>
  );
}
